import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { UsedBySectionData } from '../types'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

/**
 *  Display logos of brands that use flowcode.
 *  This component is used by both variants from FLOWCODE_LANDING_PAGE_BELOW_FOLD_Q1_2022_UPDATES
 *  V1 is white, V2 is black (dark)
 */
//sectionId is used for navigation
const UsedBySection: FC<{ data?: UsedBySectionData; dark?: boolean; sectionId?: string }> = ({
  data,
  dark,
  sectionId
}) => {
  if (!data) return null
  return (
    <Box display="block" px="16px" id={sectionId}>
      <Box
        flexDirection="column"
        maxWidth="1035px"
        mx="auto"
        p={dark ? { _: '35px 0px', md: '35px 8px', lg: '55px' } : { _: '0px' }}
        borderRadius="12px"
        backgroundColor={dark ? 'primary.black' : 'transparent'}
      >
        <PrismicText
          richTextField={data.primary?.subheader}
          fontSize={{ _: '24px', md: '28px', lg: '32px' }}
          lineHeight={{ _: '30px', lg: '40px' }}
          variant={data.primary?.subheader_variant ?? 'display/large'}
          maxWidth="866px"
          mx="auto"
          textAlign="center"
          color={dark ? 'primary.white' : 'primary.black'}
        />
        <Spacer mb="32px" />
        <Box
          display="grid"
          gridTemplateColumns={{ _: 'repeat(4, 1fr)', md: 'repeat(10, 1fr)' }}
          justifyItems="center"
        >
          {data.items?.map((item, idx) => (
            <Image key={idx} lazyLoad={true} src={item.logo.url ?? ''} alt={item.logo.alt ?? ''} />
          ))}
        </Box>
      </Box>
      <Spacer mb={{ _: '32px', md: '56px', lg: '96px' }} />
    </Box>
  )
}

export default UsedBySection
